import { LayoutContainerModel } from "../../models/containers/layout/LayoutContainerModel";

export function smoothScrollToTop() {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}

export function smoothScrollToInputError(input: HTMLInputElement) {
    input.scrollIntoView({
        behavior: "smooth",
        block: "center",
    });

    input.focus();
}

export function smoothScrollToElement(element: HTMLElement) {
    element.scrollIntoView({
        behavior: "smooth",
        block: "center",
    });
    
    element.focus();
}

export function filterOptimizeMemory(
    containers: LayoutContainerModel[], 
    toDeleteIds: number[]

) : LayoutContainerModel[] {
    const newContainers: LayoutContainerModel[] = containers.filter(
        container => !toDeleteIds.includes(container.id!)
    );

    toDeleteIds.length = 0;
    return newContainers;
}

export const getRandomInt = (min: number, max: number): number => {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
};